import * as angular from 'angular';

import { ComponentDefinition } from '../../../models';

class RolesInApplicationsController implements angular.IComponentController {
    isLoading: boolean;
    roles: string[];
    userApplicationRoles: {
        applicationName: string;
        roles: { [role: string]: boolean };
    }[];
    onApplicationClick: ({ applicationName: string });

    static $inject = [];
}

export const wtRolesInApplications: ComponentDefinition = {
    componentId: 'wtRolesInApplications',
    controller: RolesInApplicationsController,
    template: require('./rolesInApplications.component.html'),
    controllerAs: 'vm',
    bindings: {
        isLoading: '<',
        roles: '<',
        userApplicationRoles: '<',
        onApplicationClick: '&?'
    }
};
